import React, { useState } from 'react';
import { Stethoscope, Building2, MapPin, Phone } from 'lucide-react';
type Listing = {
  name: string;
  lines: string[];
  phone?: string;
};
type Tab = {
  id: string;
  label: string;
  icon: React.ElementType;
  intro: string;
  listings: Listing[];
};
const tabs: Tab[] = [{
  id: 'doctors',
  label: 'Mesothelioma Doctors',
  icon: Stethoscope,
  intro: 'California is home to several of the nation’s leading mesothelioma specialists. These thoracic surgeons and oncologists treat pleural and peritoneal mesothelioma and can provide second opinions on a new diagnosis.',
  listings: [{
    name: 'Dr. Robert B. Cameron',
    lines: ['UCLA Comprehensive Mesothelioma Program', 'Ronald Reagan UCLA Medical Center', '10833 Le Conte Avenue', 'Los Angeles, CA 90095'],
    phone: '310.825.9111'
  }, {
    name: 'Dr. David M. Jablons',
    lines: ['UCSF Helen Diller Family Comprehensive Cancer Center', 'Thoracic Oncology Program', '1600 Divisadero Street', 'San Francisco, CA 94115'],
    phone: '415.476.1000'
  }, {
    name: 'Dr. Thierry Jahan',
    lines: ['UCSF Medical Center', 'Medical Oncology — Thoracic Malignancies', '1600 Divisadero Street', 'San Francisco, CA 94115'],
    phone: '415.476.1000'
  }, {
    name: 'Dr. Joseph B. Shrager',
    lines: ['Stanford Cancer Institute', 'Division of Thoracic Surgery', '875 Blake Wilbur Drive', 'Palo Alto, CA 94304'],
    phone: '650.498.6000'
  }, {
    name: 'Dr. Dan J. Raz',
    lines: ['City of Hope Comprehensive Cancer Center', 'Division of Thoracic Surgery', '1500 East Duarte Road', 'Duarte, CA 91010'],
    phone: '800.826.4673'
  }, {
    name: 'Dr. Jae Y. Kim',
    lines: ['City of Hope Comprehensive Cancer Center', 'Thoracic Surgical Oncology', '1500 East Duarte Road', 'Duarte, CA 91010'],
    phone: '800.826.4673'
  }]
}, {
  id: 'centers',
  label: 'Mesothelioma Treatment Centers',
  icon: Building2,
  intro: 'These California cancer centers offer multidisciplinary mesothelioma care, including surgery, chemotherapy, immunotherapy, radiation, and access to clinical trials.',
  listings: [{
    name: 'UCLA Comprehensive Mesothelioma Program',
    lines: ['Ronald Reagan UCLA Medical Center', '10833 Le Conte Avenue', 'Los Angeles, CA 90095'],
    phone: '310.825.9111'
  }, {
    name: 'UCSF Helen Diller Family Comprehensive Cancer Center',
    lines: ['Thoracic Oncology Program', '1600 Divisadero Street', 'San Francisco, CA 94115'],
    phone: '415.476.1000'
  }, {
    name: 'Stanford Cancer Institute',
    lines: ['Stanford Health Care', '875 Blake Wilbur Drive', 'Palo Alto, CA 94304'],
    phone: '650.498.6000'
  }, {
    name: 'City of Hope Comprehensive Cancer Center',
    lines: ['1500 East Duarte Road', 'Duarte, CA 91010'],
    phone: '800.826.4673'
  }, {
    name: 'UC San Diego Moores Cancer Center',
    lines: ['3855 Health Sciences Drive', 'La Jolla, CA 92093'],
    phone: '858.657.7000'
  }, {
    name: 'Cedars-Sinai Cancer',
    lines: ['8700 Beverly Boulevard', 'Los Angeles, CA 90048'],
    phone: '310.423.3277'
  }, {
    name: 'UC Davis Comprehensive Cancer Center',
    lines: ['4501 X Street', 'Sacramento, CA 95817'],
    phone: '916.734.2011'
  }]
}, {
  id: 'sites',
  label: 'California Asbestos Exposure Sites',
  icon: MapPin,
  intro: 'Mesothelioma victims across California have traced their asbestos exposure to these documented job sites. This is a partial list — our investigators maintain records on thousands more statewide.',
  listings: [{
    name: 'Shipyards & Naval Facilities',
    lines: ['Hunters Point Naval Shipyard — San Francisco', 'Mare Island Naval Shipyard — Vallejo', 'Long Beach Naval Shipyard — Long Beach', 'NASSCO Shipyard — San Diego', 'Todd Shipyards — San Pedro', 'Kaiser Shipyards — Richmond', 'Naval Air Station North Island — Coronado']
  }, {
    name: 'Refineries & Chemical Plants',
    lines: ['Chevron Richmond Refinery — Richmond', 'Chevron El Segundo Refinery — El Segundo', 'Shell Martinez Refinery — Martinez', 'Phillips 66 Wilmington Refinery — Wilmington', 'Valero Benicia Refinery — Benicia', 'Kern County oilfield operations — Bakersfield']
  }, {
    name: 'Power & Utility Plants',
    lines: ['San Onofre Nuclear Generating Station — San Clemente', 'Diablo Canyon Power Plant — Avila Beach', 'PG&E generating stations — statewide', 'LADWP Scattergood & Haynes plants — Los Angeles', 'Moss Landing Power Plant — Moss Landing']
  }, {
    name: 'Steel, Cement & Manufacturing',
    lines: ['Kaiser Steel Mill — Fontana', 'Riverside Cement Company — Riverside', 'Johns-Manville plant — Pittsburg', 'Owens-Corning facilities — Santa Clara', 'Aerospace plants — San Fernando Valley & Long Beach']
  }, {
    name: 'Military Bases & Rail Yards',
    lines: ['McClellan Air Force Base — Sacramento', 'Norton Air Force Base — San Bernardino', 'Camp Pendleton — Oceanside', 'Southern Pacific rail yards — Roseville & Bakersfield', 'Sacramento Army Depot — Sacramento']
  }, {
    name: 'Schools, Hospitals & Public Buildings',
    lines: ['Los Angeles Unified School District campuses', 'County hospital and courthouse construction projects', 'University of California campus facilities', 'Municipal water and sewer infrastructure', 'Highway and tunnel construction — statewide']
  }]
}];
export function CaliforniaResources() {
  const [activeTab, setActiveTab] = useState(tabs[0].id);
  const active = tabs.find(tab => tab.id === activeTab) ?? tabs[0];
  return <section id="resources" className="py-20 md:py-24 bg-white" data-id="element-27" data-mp="30anltqorbuqh">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-28" data-mp="22sfacp8npfoa">
        <div className="max-w-3xl mb-14" data-id="element-29" data-mp="27rruv3c22anp">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-brand-900 mb-4" data-id="element-30" data-mp="27qp6p364ambh">
            California Mesothelioma Resources
          </h2>
          <p className="text-lg text-slate-700 leading-relaxed" data-id="element-31" data-mp="1v9xkv9kdxq9o">
            Getting the right medical care matters as much as getting the right
            lawyer. Below are leading California mesothelioma doctors, treatment
            centers, and documented asbestos exposure sites across the state.
          </p>
        </div>

        <div className="border border-slate-200 rounded-xl overflow-hidden" data-id="element-32" data-mp="1hay4ep710hol">
          {/* Tabs */}
          <div role="tablist" aria-label="California mesothelioma resources" className="flex flex-col sm:flex-row bg-slate-50 border-b border-slate-200" data-id="element-33" data-mp="1ciehv2qd2c7n">
            {tabs.map(tab => {
            const Icon = tab.icon;
            const isActive = tab.id === active.id;
            return <button key={tab.id} role="tab" id={`tab-${tab.id}`} aria-selected={isActive} aria-controls={`panel-${tab.id}`} onClick={() => setActiveTab(tab.id)} className={`flex items-center justify-center gap-2 px-6 py-4 text-sm font-semibold transition-colors border-b-2 sm:border-b-0 sm:border-r border-slate-200 last:border-r-0 focus:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-brand-500 ${isActive ? 'bg-white text-brand-900 border-b-brand-accent sm:border-b-0 sm:shadow-[inset_0_3px_0_0_theme(colors.brand.accent)]' : 'text-slate-600 hover:text-brand-900 hover:bg-white/60'}`} data-id="element-34" data-mp="tkbzh6sbjdit">
                  <Icon className="w-4 h-4 shrink-0" data-id="element-35" data-mp="1ts7b9bd9apco" />
                  <span data-id="element-36" data-mp="1fro9glzdwfiy">{tab.label}</span>
                </button>;
          })}
          </div>

          {/* Panel */}
          <div role="tabpanel" id={`panel-${active.id}`} aria-labelledby={`tab-${active.id}`} className="p-8 md:p-10" data-id="element-37" data-mp="1kppngshydonk">
            <p className="text-slate-600 leading-relaxed mb-10 max-w-3xl" data-id="element-38" data-mp="w6e70cyhx4kf">
              {active.intro}
            </p>

            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-39" data-mp="1a6oxhevw8h52">
              {active.listings.map(listing => <div key={listing.name} data-id="element-40" data-mp="162qzj7ib1cdl">
                  <h3 className="font-serif font-bold text-brand-900 text-lg mb-2" data-id="element-41" data-mp="1k3jwdyw2wjjv">
                    {listing.name}
                  </h3>
                  <address className="not-italic text-sm text-slate-600 leading-relaxed space-y-0.5" data-id="element-42" data-mp="1f3xkbsrzl9cn">
                    {listing.lines.map(line => <div key={line} data-id="element-43" data-mp="1ous6yy95aaym">{line}</div>)}
                  </address>
                  {listing.phone && <a href={`tel:${listing.phone.replace(/\./g, '')}`} className="inline-flex items-center gap-1.5 mt-2 text-sm font-semibold text-brand-700 hover:text-brand-900 transition-colors" data-id="element-44" data-mp="22v2y82ed9rkb">
                      <Phone className="w-3.5 h-3.5" data-id="element-45" data-mp="29nf2965eaf4s" />
                      {listing.phone}
                    </a>}
                </div>)}
            </div>
          </div>
        </div>

        <div className="mt-8 flex flex-col sm:flex-row sm:items-center gap-6 justify-between bg-brand-50 border border-brand-100 rounded-xl p-8" data-id="element-46" data-mp="1zpr0vxdaa9dn">
          <p className="text-sm text-slate-600 max-w-2xl" data-id="element-47" data-mp="2xan8bqands7v">
            <strong className="text-brand-900" data-id="element-48" data-mp="2seoh7uxxpw3r">Need help getting seen?</strong>{' '}
            We can help connect you with a California mesothelioma specialist and
            arrange a second opinion while we investigate your exposure history.
          </p>
          <a href="tel:805-770-9317" className="inline-flex justify-center items-center gap-2 bg-brand-accent hover:bg-brand-accentHover text-brand-900 px-6 py-3 rounded-md font-bold transition-colors shrink-0" data-id="element-49" data-mp="1bzdccgtwqsnt">
            <Phone className="w-4 h-4" data-id="element-50" data-mp="3ioyjpvkvqw4g" />
            (805) 770-9317
          </a>
        </div>

        <p className="mt-6 text-xs text-slate-500 leading-relaxed" data-id="element-51" data-mp="3nni9k72lgs23">
          Listings are provided for informational purposes only. Pacific Coast
          Mesothelioma Law Group is not affiliated with, and does not endorse,
          any physician or medical facility listed above. Please verify contact
          details and availability directly with each provider.
        </p>
      </div>
    </section>;
}